import React from "react";
import { useModal } from "../context/ModalContext";
import AddNewDevice from "./modals/AddNewDevice";
import ExistingDevice from "./modals/ExistingDevice";

const ModalRenderer: React.FC = () => {
  const { state, dispatch } = useModal();

  const close = () => dispatch({ type: "CLOSE" });

  switch (state.activeModal) {
    case "ADD_NEW_DEVICE":
      return <AddNewDevice onClose={close} />;
    case "EXISTING_DEVICE":
      return <ExistingDevice onClose={close} data={state.modalData} />;
    default:
      return null;
  }
};

export default ModalRenderer;
